import { jsxs, jsx } from 'react/jsx-runtime';
import { CheckMiniIcon } from '@iris/react-icons/CheckMiniIcon';
import componentStyles from './SelectDropdown.styles.esm.js';

function SelectDropdownItem({ item, selectedValue, showQuantity, inverse, onClick, tabIndex, }) {
    const { item: itemClasses, icon: iconClasses, iconWrapper: iconWrapperClasses, label: labelClasses, count: countClasses, } = componentStyles({
        inverse,
        disabled: item === null || item === void 0 ? void 0 : item.disabled,
    });
    const getDataState = (item) => {
        return item.disabled
            ? "disabled"
            : item.value === selectedValue
                ? "selected"
                : "default";
    };
    return (jsxs("li", { "data-state": getDataState(item), "data-value": item.value, className: itemClasses(), tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (item.disabled ? -1 : 0), id: item.value, "aria-disabled": item.disabled, role: "option", onClick: (e) => {
            if (onClick && !item.disabled) {
                e.preventDefault();
                onClick(item.value);
            }
        }, onKeyDown: (e) => {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                if (onClick && !item.disabled) {
                    onClick(item.value);
                }
            }
        }, "aria-label": `${item.label}${showQuantity && item.quantity ? `, ${item.quantity}` : ""} ${!item.disabled ? "available" : ""} ${item.value === selectedValue ? "selected" : ""}`, children: [item.value === selectedValue && (jsx("div", { className: iconWrapperClasses(), children: jsx(CheckMiniIcon, { className: iconClasses() }) })), jsx("span", { "data-state": getDataState(item), className: labelClasses(), "aria-hidden": "true", children: item.label }), showQuantity && (jsx("span", { className: countClasses(), "aria-hidden": "true", children: `(${item.quantity})` }))] }));
}

export { SelectDropdownItem };
